/**
 * Format a date string to a readable date format
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted date
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date
    .toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    .replace(',', '');
};

/**
 * Format a date string to a time format
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted time
 */
export const formatTime = (dateString) => {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Convert to 12-hour format
  const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const ampm = hours < 12 ? 'am' : 'pm';

  // Only show minutes if not zero
  if (minutes === 0) {
    return `${hour12}${ampm}`;
  } else {
    return `${hour12}:${minutes.toString().padStart(2, '0')}${ampm}`;
  }
};

/**
 * Format a date string to a date and time format
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted date and time
 */
export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};